import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';
import { initSentry } from './lib/sentry';
import { AppErrorBoundary } from './app/ErrorBoundary';
import { AppProviders } from './app/providers';
import { App } from './app/App';

// Initialize Sentry before rendering the app
initSentry();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <AppProviders>
          <App />
        </AppProviders>
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>
);
